<template>

  <iMineTemplate :page-title="pageTitle" :actived-parent-key="activedParentKey" :actived-key="activedKey">
    <template #rightContent>
      <div class="storeinfo">
        <div class="title" style="position: relative;">
          <span>门店信息</span>
        </div>
        <div class="content">
          <van-row v-for="Address in AddressInfo" :key="Address.Name" type="flex">
            <van-col span="3">
              <span class="name">{{ Address.Name }}</span>
            </van-col>
            <van-col span="16">
              <div class="info">{{ Address.Content }}</div>
            </van-col>
          </van-row>
        </div>
      </div>
    </template>
  </iMineTemplate>
</template>

<script>
import { BaseMixin } from '@/mixins/BaseMixin'
export default {
  name: 'StoreInfo',
  mixins: [BaseMixin],
  data() {
    return {
      pageTitle: ['我的账户', '门店信息'],
      activedParentKey: 1,
      activedKey: 12,
      iconnote: require('@/assets/mine/note.png'),
      AddressInfo: [
        { Name: '企业名称', Content: '' },
        {
          Name: '联系人',
          Content: ''
        },
        {
          Name: '联系方式',
          Content: ''
        },
        {
          Name: '收货地址',
          Content: ''
        }
      ],
      urls: {
        CustomerContactDetail: '/api_customers/Customer/CustomerContactDetail'
      }
    }
  },
  mounted() {
    this.loadStore()
  },
  methods: {
    // 加载店铺数据
    async loadStore() {
      const that = this
      this.$hys.openLoading()
      const res = await this.getAction(this.urls.CustomerContactDetail)
      this.$hys.clearLoading()
      if (!res.IsSuccess) {
        this.$toast({ position: 'bottom', message: res.Msg })
        return
      }
      // console.log(that.AddressInfo[0]);
      that.AddressInfo[0].Content = res.Data.CustomerName
      that.AddressInfo[1].Content = res.Data.ContactsName
      that.AddressInfo[2].Content = res.Data.Phone
      that.AddressInfo[3].Content = res.Data.Address
    }
  }
}
</script>
<style lang="less" scoped>
  .storeinfo {
    // padding: 20px;
    position: relative;
    margin: 0 20px 20px 0;
    border: 1px solid rgba(232, 232, 232, 1);
    border-radius: 2px;
    padding: 20px;
    width: 940px;
    height: 313px;
    font-size: 16px;
    background: rgba(255, 255, 255, 1);
    box-sizing: border-box;

    .title {
      border-bottom: 1px solid #E8E8E8;
      width: 898px;
      height: 42px;
      line-height: 22px;

      span {
        float: left;
        font-size: 18px;
        color: rgba(34, 34, 34, 1);
      }
    }

    .content {
      padding: 20px;
      width: 898px;
      font-weight: 400;
      text-align: left;
      line-height: 40px;
      box-sizing: border-box;

      .name {
        color: rgba(119, 119, 119, 1);
      }

      .info {
        color: rgba(34, 34, 34, 1);
      }
    }
  }
</style>
